jQuery(function($) {

    'use strict';

    var $menu = $("#menu"),
        $container = $('#container'),
        $window = $(window),
        $contentImg = $('.content img'),

        isTouchDevice = !!('ontouchstart' in window);
        $("body").addClass(isTouchDevice ? "touch" : "not-touch");

    // MENU

    $('.nav-main-link:last').click(
        function(){
           window.open(this.href);
           return false;
        }
    );

    //FOOTER

    $('.nav-footer-link:last').click(
        function(){
            window.open(this.href);
            return false;
        }
    );

    //MASONRY

    if ($container.length) {
        var container = document.querySelector('#container');
        var msnry;
        imagesLoaded( container, function() {
            setTimeout(function() {
                var options = {
                    itemSelector: '.item',
                    gutterWidth: 0,
                    gutter: 0
                };

                if ($( window ).width()>1023) {
                    options.columnWidth = 76;
                }

                msnry = new Masonry( container, options);

                $(".item").css("opacity", "1");
            }, 0);
        });
    }


    //MENU
    let leaveTimeout;

    // Manages open/close on mouse leave
    var menuCtrl = {

        $menu: $("#menu"),
        timerID: null,

        isOpen: function() {
            return !this.$menu.hasClass('burger');
        },

        isHover: function() {
            return this.$menu.is(':hover');
        },

        open: function() {
            this.$menu.removeClass('burger');
        },

        close: function(timer) {
            this.cancelClose();

            if (!timer) {
                this.$menu.addClass('burger');
            } else {
                var _this = this;

                this.timerID = setTimeout(function() {
                    _this.$menu.addClass('burger');
                }, timer);
            }
        },

        toggle: function(shouldOpen) {
            if (typeof shouldOpen == 'undefined') {
                if (this.isOpen()) {
                    this.close();
                } else {
                    this.open();
                }
            } else {
                if (shouldOpen) {
                    this.open();
                } else {
                    this.close();
                }
            }
        },

        cancelClose: function() {
            clearTimeout(this.timerID);
        }

    };

    $('.burger_pointer').on('click', function() {
        menuCtrl.toggle();
    });

    if ($window.width() > 1023) {

        menuCtrl.$menu.on('mouseenter', function() {
            menuCtrl.cancelClose();
        });

        //MENU PAGE ACCUEIL
        if($('.accueil').length) {
            var currentScroll = 0;

            menuCtrl.$menu.on('mouseleave', function() {
                if ($window.scrollTop() !== 0) {
                    menuCtrl.close(5000);
                }
            });

            // Shows/Hides the menu with the scroll
            $window.scroll(function (event){

                if ($window.width() <= 1023) return;

                var nextScroll = $(this).scrollTop();

                if (nextScroll > currentScroll){
                    if (!menuCtrl.isHover() && $window.scrollTop() > 20) {
                        menuCtrl.close();
                    } else {
                        menuCtrl.cancelClose();
                    }
                } else {
                    menuCtrl.open();
                    if (!menuCtrl.isHover() && $window.scrollTop() > 20) {
                        menuCtrl.close(5000);
                    } else if ($window.scrollTop() <= 20){
                        menuCtrl.cancelClose();
                    }
                }

                currentScroll = nextScroll;
            });
        }

        //MENU TOUTES LES PAGES SAUF ACCUEIL
        else {
            var currentScroll = 0,
                hasScrolledPastContainer = false;

            menuCtrl.$menu.on('mouseleave', function() {
                menuCtrl.close(5000);
            });

            // Shows/Hides the menu with the scroll
            $window.add('.page').scroll(function (event){

                if ($window.width() <= 1023) return;

                if ($container.length) {
                    if (!hasScrolledPastContainer) {
                        return;
                    }
                }

                var nextScroll = $(this).scrollTop();

                if (nextScroll > currentScroll){
                    if (!menuCtrl.isHover() && $window.scrollTop() >20) {
                        menuCtrl.close();
                    } else {
                        menuCtrl.cancelClose();
                    }
                }
                else {
                    var $page = $('.page'),
                        isTop = $($page.length ? $page : $window.scrollTop() >20);

                    menuCtrl.toggle(isTop);
                    menuCtrl.close(5000);
                }

                currentScroll = nextScroll;
            });

            if ($container.length) {

                var waypoint = new Waypoint({
                    element: $container,
                    handler: function(direction) {
                        hasScrolledPastContainer = direction === "down";
                        menuCtrl.close();

                    }, offset: 100
                });
            }

        }

    }


    //PAGE BOOK

    $('.book').each(function() {
        var mySwiper = new Swiper($(this).find('.swiper-container'), {
          // Optional parameters
          initialSlide: 0,
          direction: 'horizontal',
          speed: 0,
          loop: true,
          width: ('.swiper-container').offsetWidth,
          height: 500,
          spaceBetween: 0,
          nextButton: $(this).find('.swiper-button-next'),
          prevButton: $(this).find('.swiper-button-prev')
        });
    });


    //PAGE SINGLE-PHOTO
    if ($('#photo').length) {

        function chargerTitresPhoto () {
                $(".photo_index").html($(".swiper-slide-active").find("img").attr('data-image'));
                $(".photo_titre").html($(".swiper-slide-active").find("img").attr('data-titre'));
                $(".photo_ville").html($(".swiper-slide-active").find("img").attr('data-ville'));
                $(".photo_pays").html($(".swiper-slide-active").find("img").attr('data-pays'));
        }

        if ($('.swiper-container').length) {
            var mySwiper = new Swiper ('.swiper-container', {
                 // Optional parameters
                 initialSlide: 0,
                 direction: 'horizontal',
                 speed: 0,
                 loop: true,
                 height: $('.swiper-container').offsetHeight,
                 spaceBetween: 0,
                 nextButton: '.swiper-button-next',
                 prevButton: '.swiper-button-prev',
                 onInit: function() {
                    chargerTitresPhoto();
                 }
            });


            mySwiper.on('slideChangeStart', function () {
                chargerTitresPhoto();
            });


            var waypoint = new Waypoint({
              element: $container,
              handler:
              function(direction) {

                if (direction === 'down') {
                    $('#photo').addClass("noWhiteCache");

                } else {
                    $('#photo').removeClass("noWhiteCache");
                }
              },
              offset: 100
            });
        }
    }

    //MOBILE

    if ($window.width() <= 1023) {
        $('#menu').addClass('burger');
    }

    // The following code is a bug fix for iPad. The positions of the lines aren't correctly applied in CSS on iPad, so
    // we force them through some JavaScript code.
    $window.on('resize', function() {
        const IS_MOBILE = $window.width() <= 1023;

        $('#menu .line:nth-child(2)').css('top', IS_MOBILE ? 10 : '');
        $('#menu .line:nth-child(3)').css('top', IS_MOBILE ? 20 : '');
    }).on('load', () => $window.trigger('resize'));


    //CURSOR
    $('.swiper-button-next, .swiper-button-prev').mouseleave(function(){
        $('.cursor').hide();
    });

    $('.swiper-button-next').mouseenter(function(){
       $('#mycursorNext').show();
    });
    $('.swiper-button-prev').mouseenter(function(){
       $('#mycursorPrev').show();
    });

    $('.swiper-button-prev').mousemove(function(e){
        $('.cursor').css('left', e.clientX).css('top', e.clientY + $(window).scrollTop());
    });  
    $('.swiper-button-next').mousemove(function(e){
        $('.cursor').css('left', e.clientX).css('top', e.clientY + $(window).scrollTop());
    });    

});
